import {enumType} from '../common/enumType';

export const TransactionType = enumType({
   INBOUND: 'Inbound',
   OUTBOUND: 'Outbound',
   SYNCHRONIZATION: 'Synchronization',
});
